import { PaziaButton, PaziaInput, PaziaTextarea } from "components/atoms";
import React from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { FormProvider, useForm } from "react-hook-form";

const schema = yup
  .object({
    name: yup.string().required().matches(/^\S*$/, "Niepoprawny format. Znak ' '."),
    value: yup.string().required(),
  })
  .required();

export type CreateParameterFormValues = yup.InferType<typeof schema>;

interface CreateParameterFormProps {
  onSubmit: (data: CreateParameterFormValues) => void;
}
export const CreateParameterForm = ({ onSubmit }: CreateParameterFormProps) => {
  const methods = useForm({
    resolver: yupResolver(schema),
  });

  const { handleSubmit } = methods;

  // TODO parametr musi zaczynac sie od {{}}
  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-2">
        <div className="flex flex-col gap-4">
          <div>Dodawanie nowego parametru</div>
          <div className="flex-col gap-2 flex">
            <PaziaInput label="Nazwa" name="name" required />
            <PaziaTextarea label="Wartość" name="value" required />
          </div>
          <div className="self-end">
            <PaziaButton type="success" title="Dodaj parametr" />
          </div>
        </div>
      </form>
    </FormProvider>
  );
};
